export enum BenefitProgram {
  None = 'None',
  LOFavor = 'LOFavor',
  BBL = 'BBL',
  IceAmbassador = 'IceAmbassador',
  Demo = 'Demo',
  Fordel = 'Fordel',
  FLR = 'FLR',
  Unknown = 'Unknown',
}
